import { FC } from 'react';
import './AnswerMessage.scss';
import { OpenAiLogo } from '../../Common/OpenAiLogo';
import { Image, Spinner } from '@fluentui/react-components';
import { getGptIconAsset } from '../../../Utils/image';
import { useConversations } from '../../../store/hooks';

export const AnswerLoading: FC = () => {
    const { activeGpt } = useConversations();

    return (
        <div className='answerMessage'>
            <div className='inner'>
                <div className={activeGpt?.isDefault ? 'defaultGptLogo' : 'gptLogo'}>
                    {activeGpt?.isDefault ?
                        <OpenAiLogo size='small'/>
                        : 
                        <Image src={getGptIconAsset(activeGpt?.icon)} />
                    }
                </div>
                <div className='content'>
                    <Spinner appearance='primary' label='' />
                </div>
            </div>
        </div>
    );
};
